import type { ToothSliceSource } from '../config';

export const isFullHeadMprSlicesUnavailable = ({
  input,
  isVolumeReady,
}: {
  input: ToothSliceSource | null;
  isVolumeReady: boolean;
}) => input?.kind === 'legacy' || (isVolumeReady && input === null);
